




























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { statisticDetailTimes } from '@/constants/type-helper';
import { namespace } from 'vuex-class';
import { TargeMixin } from '@/mixins';
import { AcgnFormTitle } from '@/components/';
import { openUrl } from '@/util';
import {
  AcgnTable,
} from '@acgn/herm/src/ui';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;
const ComicAction = namespace('desk/comic').Action;
const StaffAction = namespace('desk/staff').Action;
const StatisticNorGetter = namespace('desk/statisticNor').Getter;
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {
    AcgnTable,
    AcgnFormTitle
  },
  mixins: [TargeMixin]
})

/**
 * 目标情况
 */
export default class AcgnTargetDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  @StatisticNorAction private getTargetCycleDetail: any;
  @StatisticAction private getTargetCycleAdminDetail: any;
  @ComicAction private getProjectDetail: any; // 项目详情
  @StaffAction private getStaffTargetDetail: any; // 员工目标详情

  @StatisticNorGetter private loadings: any; // loading
  @CommGetter private attributeData: any; // 公共类型

  private selectOpts: any = statisticDetailTimes;
  private targetInfo: any = {};

  private apiKey: any = {
    1: 'getTargetCycleDetail',
    2: 'getTargetCycleAdminDetail'
  };
  private apiUrls: any = {
    1: 'v1/workbench/targetcycle',
    2: 'v1/workbench/gettargetcycleofadmin'
  };

  private tableConfig: any = {
    columns: [
      {
        label: '时间',
        prop: 'time_slot',
        width: 200
      },
      {
        label: '完成数',
        prop: 'finished_num'
      },
      {
        label: '目标数',
        prop: 'target_num'
      },
      {
        label: '是否达成目标',
        prop: 'finshed',
        render: (h: any, { row }: any) => `${row.finshed ? '已' : '未'}达成`
      }
    ],
    data: []
  };

  private pageConfig: any = {}; // 分页数据

  private async created() {
    let result;
    if (this.userId) {
      result = (await this.getStaffTargetDetail({ project_id: this.comicId, user_id: this.userId })).result;
    } else {
      result = (await this.getProjectDetail({ project_id: this.comicId })).result;
    }
    this.targetInfo = result;
  }

  // table组件获取数据更新数据接口
  private async initSearh() {
    const { tableConfig, pageConfig } = this;
    const options = this.getSearchOptions();

    const { result } = await (this as any)[this.apiKey[this.type]](options);
    tableConfig.data = result;
  }

  private getSearchOptions() {
    return {
      project_id: this.comicId,
      user_id: this.userId
    };
  }

  private exportExcel() {
    openUrl(`/api/${this.apiUrls[this.type]}?export=1`, this.getSearchOptions());
  }
}
